// extracted by mini-css-extract-plugin
module.exports = {"root":"ActivityDot_root__3OM26"};